import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { DirectCarrierSettings } from '@shipstation/connections-ui/direct';

import { noop } from 'ui-components/default-props/noop';

import { useCuiApiConfig } from './helpers/use-cui-api-config';
import { useCuiContextProps } from './helpers/use-cui-context-props';

const defaultSellerData = { shipFroms: [] };

export const CuiProviderSettings = ({
  providerType,
  providerApiCode,
  accountId,
  onSave = noop,
  onCancel = noop,
  onError = noop,
  onUpdateSellerData = noop,
  sellerData = defaultSellerData,
}) => {
  const cuiApiConfig = useCuiApiConfig();
  const cuiContextProps = useCuiContextProps();

  const contextProps = useMemo(
    () => ({
      ...cuiContextProps,
      onCancel,
      onError,
      onSave,
      onUpdateSellerData,
      sellerData,
    }),
    [cuiContextProps, onCancel, onError, onSave, onUpdateSellerData, sellerData],
  );

  return (
    <DirectCarrierSettings
      accountId={accountId}
      apiConfig={cuiApiConfig}
      contextProps={contextProps}
      providerApiCode={providerApiCode}
      providerType={providerType}
    />
  );
};

CuiProviderSettings.propTypes = {
  providerApiCode: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
  providerType: PropTypes.string.isRequired,
  onError: PropTypes.func,
  onSave: PropTypes.func,
  onUpdateSellerData: PropTypes.func,
  onCancel: PropTypes.func,
  sellerData: PropTypes.shape({ shipFroms: PropTypes.array }),
};
